import { render, staticRenderFns } from "./purchaseStock.vue?vue&type=template&id=fc2281b2"
import script from "./purchaseStock.vue?vue&type=script&lang=js"
export * from "./purchaseStock.vue?vue&type=script&lang=js"
import style0 from "./purchaseStock.vue?vue&type=style&index=0&id=fc2281b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports